// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__16Jl_","selected":"Chip_selected__2-4cU"};